import React, { useState } from 'react'
import { Button, ButtonGroup, Form } from 'react-bootstrap'
import RegisterCard from './RegisterCard'
import LoginCard from './LoginCard'

const LoginScreen = () => {

    const [authType, setAuthType] = useState("signin")

    return (
        <>
            <section className='mt-5'>
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <h3 className='text-center fw-bold'>Popgop Referral System</h3>
                            <p className='text-center'>Sign in to manage your referral and earning</p>
                            <div className='p-1 bg-light shadow-sm rounded'>
                                <ButtonGroup className='w-100' aria-label="Basic example">
                                    <Button onClick={() => setAuthType("signin")} className={`${authType === "signin" ? "bg-badge " : "bg-light text-dark"} border-0`}>Login</Button>
                                    <Button onClick={() => setAuthType("register")} className={`${authType === "register" ? "bg-badge " : "bg-light text-dark"} border-0`}>Register</Button>
                                </ButtonGroup>
                            </div>

                            {authType === "register" ? (
                                <>
                                    <RegisterCard />
                                </>
                            ) : (
                                <>
                                    <LoginCard />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default LoginScreen